export default "__VITE_ASSET__DO1fHOKJ__"